export const se = {
  Advarsel: "Varning",
  Aksjonskort: "Störningsplan",
  "Aktive infrastrukturhendelser": "Aktiva infrastrukturhändelser",
  "Aktive stasjonshendelser": "Aktiva stationshändelser",
  Alpha: "Alpha",
  "alle dager": "alla dagar",
  "Alle dager": "Alla dagar",
  "Alle dine endringer vil gå tapt. Det er ikke mulig å angre dette valget.":
    "Alla dina ändringar kommer att gå förlorade. Det är inte möjligt att ångra detta val.",
  Alle: "Alla",
  Alvorlighetsgrad: "Alvarlighetsgrad",
  "Ankom brudd: {{time}}": "Ankom störning {{time}}",
  Ankomst: "Ankomst",
  annenhver: "varannan",
  Annonsert: "Annonserad",
  Anvisere: "Anvisare",
  Arbeidsliste: "Arbetslista",
  Avbryt: "Avbryt",
  Avgang: "Avgång",
  Avmarker: "Avmarkera",
  "Avmarker Alle": "Avmarkera alla",
  "Avmarker valgte": "Avmarkera valda",
  "Avstengt togsett": "Avstängd tågsätt",
  Avstigning: "Avstigning",
  "Avvik på": "Avvik på",

  "Bakre togsett": "Bakre tågsätt",
  "Behandle tog": "Behandla tåg",
  "Behandle {{count}} tog": "Behandla {{count}} tåg",
  "Behandles...": "Behandlas...",
  Behandlet: "Behandlad",
  Beklager: "Beklagar",
  "Beklager, men vi lyktes ikke med å koble til. Vennligst logg ut og prøv igjen.":
    "Beklagar, men vi lyckades inte koppla upp. Vänligen logga ut och försök igen.",
  Bemanning: "Bemanning",
  berørt: "påverkad",
  Bravo: "Bravo",
  "Bruker ({{username}}) er ikke registrert i Puzzel. Ta kontakt med admin":
    "Användare ({{username}}) är inte registrerad i Puzzel",
  "Beskriv hendelsen og årsaken kortfattet og tydelig.":
    "Beskriv händelsen och orsaken kortfattat och tydligt.",
  Buss: "Buss",

  Charlie: "Charlie",
  "{{count}} brudd_other": "{{count}} störningar",
  "{{count}} brudd": "{{count}} störning",
  "{{count}} tog valgt": "{{count}} tåg valda",

  Dato: "Datum",
  Dekning: "Täckt område",
  "Del med": "Dela med",
  "Marker med": "Markera med",
  "Marker som": "Markera som",
  Delta: "Delta",
  Depubliser: "Avpublicera",
  depublisere: "avpublicera",
  Depublisert: "Avpublicerad",
  "Dersom feilen er gjentakende, send gjerne en liten beskrivelse om hvordan du gikk frem da feilen oppsto":
    "Om felet är återkommande, skicka gärna en liten beskrivning om hur du gick tillväga när felet uppstod",
  "Det er ikke registrert noen fremtidige hendelser":
    "Det finns inga registrerade framtida händelser",
  "Det er ingen behandlede tog for øyeblikket":
    "Det finns inga behandlade tåg för tillfället",
  "Det er ingen ikke berørte tog for øyeblikket":
    "Det finns inga icke-påverkade tåg för tillfället",
  "Det er ingen ubehandlede tog for øyeblikket":
    "Det finns inga obehandlade tåg för tillfället",
  "Det er problemer med tilkoblingen til serveren. Vennligst kontroller din nettverksforbindelse, eller last inn siden på nytt.":
    "Det är problem med anslutningen till servern. Vänligen kontrollera din nätverksanslutning, eller ladda om sidan.",
  "Dette er en oppsummering av informasjon som sendes ut om denne hendelsen. Ordlyden tilpasses etter mottaker.":
    "Detta är en sammanfattning av information som skickas ut om denna händelsen. Formuleringen anpassas efter mottagaren.",
  "Dette toget eksisterer allerede i et annet produksjonsavvik i valgt periode":
    "Detta tåg finns redan i en annan produktionsavvikelse i vald period",
  "Din økt har utløpt. Vennligst logg inn på nytt for å fortsette.":
    "Din session har gått ut. Vänligen logga in igen för att fortsätta.",
  "Det finnes ikke passeringsmeldinger for dette stoppet":
    "Det finns inte passeringsmeddelanden för detta stopp",
  Distribusjon: "Distribution",
  "Drops Dashboard": "Drops Dashboard",
  "Drops Dashbord får ikke kontakt med tjener. Dette kan skyldes nettverksproblemer.":
    "Drops Dashboard får inte kontakt med servern. Detta kan bero på nätverksproblem.",
  "Du har endret infrastrukturhendelsen på en måte som kanskje påvirker den globale meldingen":
    "Du har ändrat infrastrukturhändelsen på ett sätt som kanske påverkar det globala meddelandet",
  "Du har ikke tilgang til Drops Dashboard":
    "Du har inte tillgång till Drops Dashboard",
  "Skriv inn tekst her...": "Skriv in text här...",
  "Dyrefri vogn": "Djurfri vagn",
  "Dyr tillatt vogn": "Djur tillåten vagn",

  "Egendefinert hendelse": "Egendefinierad händelse",
  "Eksempel: Eksterne kanaler": "Exempel: Externa kanaler",
  "Eksempel: Interne kanaler": "Exempel: Interna kanaler",
  "Ekstra stasjon": "Extra station",
  Endre: "Ändra",
  "Endre strekning": "Ändra sträcka",
  "Endre strekningsnavn*": "Ändra streckningsnamn*",
  "En feil har oppstått": "Ett fel har uppstått",
  "Engelsk beskrivelse": "Engelsk beskrivning",
  "Engelsk tekst": "Engelsk text",
  "Engelsk tittel": "Engelsk titel",
  "Er du sikker?": "Är du säker?",
  "Er du sikker på at du vil": "Är du säker på att du vill",
  "Er du sikker på at du vil friskmelde følgende tog?":
    "Är du säker på att du vill friskmelda följande tåg?",
  "Er i produksjonsavvik": "Är i produktionsavvik",
  Erstattet: "Ersatt",
  "Estimert antall passasjerer": "Beräknat antal resenärer",

  Familievogn: "Familjevagn",
  "Fant ingen informasjon om bemanning på dette toget.":
    "Ingen information om bemanning på detta tåg hittades.",
  "Fant ingen informasjon om togsammensetning.":
    "Ingen information om togsammansättning hittades.",
  "Fant ingen operative tog for øyeblikket":
    "Fant inga operativa tåg för tillfället",
  "Fant ingen registrerte hendelser på dette toget.":
    "Fant inga registrerade händelser på detta tåg.",
  "Fant ingen rute for dette toget.": "Ingen rutt hittades för detta tåg",
  "Oppdater siden for å gå tilbake": "Uppdatera sidan för att gå tillbaka",
  Filter: "Filter",
  "Filteret gir ingen treff": "Filtret ger inga träffar",
  "Filtrer på:": "Filtrera på:",
  "Ny melding": "Nytt meddelande",
  "Ny to-do": "Ny to-do",
  Send: "Skicka",
  "Send også til To-do": "Skicka även till To-do",
  "Filtrér på strekning og togserie:": "Filtrera på sträcka och tågserie:",
  "Filtrér på strekning eller togserie(r)":
    "Filtrera på sträcka eller tågserie(r)",
  "Fjern filter": "Ta bort filter",
  "Fjern filtre": "Ta bort filter",
  "Fjern valgte": "Ta bort valda",
  "For område": "För område",
  "Forsinkelse forventes": "Försening förväntas",
  "Forsinkelse (min)": "Försening (min)",
  "For togserien_one": "För tågserien",
  "For togserien_other": "För tågserierna",
  Forsinket: "Försenad",
  "Forventet forsinkelse (min)": "Förväntad försening (min)",
  fra: "från",
  Fra: "Från",
  "Fra dato": "Från datum",
  "Fra kl": "Från kl",
  "Fra og med stasjon*": "Från och med station*",
  "Fra stasjon*": "Från station*",
  fre: "fre",
  "Fremre togsett": "Främre tågsätt",
  Fremtidige: "Framtida",
  "Fremtidige hendelser": "Framtida händelser",
  Friskmeld: "Friskmelda",
  "Friskmeld {{count}} tog": "Friskmeld {{count}} tåg",
  friskmelde: "friskmelda",
  Friskmeldt: "Friskmeldt",
  "Friskmeld tog": "Friskmeld tåg",
  "Fungerende toaletter": "Fungerande toaletter",
  "Fyll ut obligatoriske felter for å se informasjonen.":
    "Fyll ut obligatoriske felter för att se informationen.",
  "Følgende stopp er allerede innstilt:": "Följande stopp är redan inställt:",
  "Får ikke kontakt med tjener": "Får inte kontakt med servern",

  "Gammel kapasitet": "Gammal kapacitet",
  "Gammel rute:": "Gammal rutt:",
  "Generell informasjon": "Generell information",
  "Gjeldende tog": "Gällande tåg",
  Gjentas: "Upprepas",
  Gjenåpne: "Återöppna",
  "Gjenåpne hendelse": "Återöppna händelse",
  "Global driftsmelding": "Globalt meddelande",
  Global: "Global",
  Globale: "Globala",
  "Global hendelse": "Global händelse",
  "Gruppereise/assistanse": "Gruppresor/assistance",
  Gul: "Gul",
  "Gå en dag frem": "Gå en dag framåt",
  "Gå en dag tilbake": "Gå en dag tillbaka",

  Handling: "Åtgärd",
  "Har du prøvd noen steg for å løse problemet?":
    "Har du provat några steg för att lösa problemet?",
  "Hei Team Brukerflater Drops": "Hej Team Brukerflater Drops",
  hendelse: "händelse",
  Hendelse_one: "Händelse",
  Hendelse_other: "Händelser",
  "Hendelse endret": "Händelse ändrad",
  "hendelsen?": "händelsen?",
  "Hendelsene kan redigeres eller friskmeldes fra ":
    "Händelserna kan redigeras eller friskmeldas från ",
  "Hendelsen er aktiv mellom": "Händelsen är aktiv mellan",
  "Hendelsen inneholder egendefinert tekst. Sjekk at oppsummeringen ser riktig ut før du går videre.":
    "Händelsen innehåller egendefinierad text. Kontrollera att sammanfattningen ser korrekt ut innan du går vidare.",
  "Hendelsen inneholder egendefinert tekst. Sjekk at beskrivelsen ser riktig ut før du går videre.":
    "Händelsen innehåller egendefinierad text. Kontrollera att beskrivningen ser korrekt ut innan du går vidare.",
  "Hendelse opprettet": "Händelse skapad",
  "Hele landet": "Hela landet",
  "Hele toget": "Hela tåget",
  "Hel strekning": "Hel sträcka",
  her: "här",
  "Hva har skjedd, og hva gjorde du da det skjedde?":
    "Vad har hänt, och vad gjorde du när det hände?",
  hver: "varje",
  "Hver uke": "Varje vecka",
  "Hver 2. uke": "Varannan vecka",
  Hvile: "Vila",
  "Hvis aktuelt:": "Om aktuellt:",
  "hvis feilen vedvarer.": "om felet kvarstår.",
  Høyttalere: "Högtalare",

  "i dag": "i dag",
  "i går": "i går",
  "Ikke berørt": "Inte påverkad",
  "ikke berørt": "inte påverkad",
  "Ikke fra samme brudd som valgte tog":
    "Inte från samma störning som valda tåg",
  "Ikke valgt": "Inte vald",
  "i morgen": "i morgon",
  Informasjon: "Information",
  "Informasjon som sendes ut": "Information som skickas ut",
  Infrastruktur: "Infrastruktur",
  infrastrukturhendelse: "infrastrukturhändelse",
  Infrastrukturhendelse: "Infrastrukturhändelse",
  Infrastrukturleverandør: "Infrastrukturleverantör",
  "Ingen handling valgt": "Ingen åtgärd vald",
  "Ingen omkjøringer finnes": "Inga omledningssträckor finns",
  "Ingen passeringsmeldinger for dette stoppet.":
    "Inga passeringsmeddelanden för detta stopp.",
  "Ingen rolle": "Ingen roll",
  "Ingen tog som kjører i valgt tidsperiode":
    "Inga tåg som går under vald tidsperiod",
  "Ingen treff": "Inga träffar",
  "Ingen årsak": "Ingen orsak",
  Innstilt: "Inställt",
  "Innstilt fra {{infrastructureProvider}}":
    "Inställt hos {{infrastructureProvider}}",
  "Innstilt på stopp": "Inställt på stopp",
  "Interne meldinger": "Interna meddelanden",
  "Intern melding": "Intern meddelande",
  "I-sirk": "BI",
  "I tidsrommet": "I tidsperioden",

  "Ja, depubliser": "Ja, avpublicera",
  "Ja, forkast": "Ja, förkasta",
  "Ja, friskmeld": "Ja, friskmelda",

  Kafévogn: "Kafévagn",
  "Kan ikke depublisere allerede usynlig hendelse":
    "Kan inte avpublicera redan osynlig händelse",
  Kiosk: "Kiosk",
  "(Kilde: {{source}})": "(Källa: {{source}})",
  Kode: "Kod",
  "Knytt hendelse til infrastrukturhendelse":
    "Knyta händelse till infrastrukturhändelse",
  "Komplett kiosk": "Komplett kiosk",
  Kond: "Kond",
  "kontakt Brukerflater DROPS": "kontakta Brukerflater DROPS",
  Konsekvens: "Konsekvens",
  "Kontrollér opprinnelig strekning i strekningsnavn":
    "Kontrollera ursprunglig sträcka i sträckningsnamn",
  "Kopiér telefonnummer": "Kopiera telefonnummer",
  "Kopierte {{string}} til utklippstavlen.":
    "Kopierade {{string}} till urklippstavlan.",
  Kort: "Kort",
  "Kunne ikke depublisere hendelsen": "Kunde inte avpublicera händelsen",
  "Kunne ikke endre hendelse.": "Kunde inte ändra händelse.",
  "Kunne ikke endre produksjonsavvik.": "Kunde inte ändra produktionsavvik.",
  "Kunne ikke finne distribusjonstekst": "Kunde inte hitta distributionstext",
  "Kunne ikke friskmelde hendelsen": "Kunde inte friskmelda händelsen",
  "Kunne ikke hente berørte tog for enkelte hendelser":
    "Kunde inte hämta berörda tåg för vissa händelser",
  "Kunne ikke hente berørte tog for hendelsen":
    "Kunde inte hämta berörda tåg för händelsen",
  "Kunne ikke hente data for ytterligere {{count}} hendelser_one":
    "Kunde inte hämta data för ytterligare {{count}} händelse.",
  "Kunne ikke hente data for ytterligere {{count}} hendelser_other":
    "Kunde inte hämta data för ytterligare {{count}} händelser.",
  "Kunne ikke hente global driftsmelding":
    "Kunde inte hämta globalt meddelande",
  "Kunne ikke hente hendelser for stasjon.":
    "Kunde inte hämta händelser för station.",
  "Kunne ikke hente mottakere fra Operational Text-tjenesten":
    "Kunde inte hämta mottagare från Operational Text-tjänsten",
  "Kunne ikke hente oppsummering.": "Kunde inte hämta sammanfattning.",
  "Kunne ikke hente ut stoppene til toget.":
    "Kunde inte hämta ut stoppen för tåget.",
  "Kunne ikke hente rutedata. Listen med omkjøringer blir ikke filtrert automatisk. Pass på at du velger riktig omkjøring.":
    "Kunde inte hämta ruttdata. Listan med omledningssträckor blir inte filtrerad automatiskt. Se till att du väljer rätt sträcka.",
  "Kunne ikke hente tognummer eller dato for dette toget.":
    "Kunde inte hämta tågnummer eller datum för detta tåg.",
  "Kunne ikke kopiere til utklippstavlen. Vennligst prøv igjen.":
    "Kunde inte kopiera till urklippstavlan. Försök igen.",
  "Kunne ikke markere som ": "Kunde inte markera som ",
  "Kunne ikke opprette hendelse.": "Kunde inte skapa händelse.",
  "Kunne ikke opprette produksjonsavvik.": "Kunde inte skapa produktionsavvik.",
  Kundeveiledere: "Kundvägledare",
  "Antall kundeveiledere som er anbefalt å sette inn på stasjoner påvirket av bruddet. Antallet er definert i tiltakskortet.":
    "Antal kundvägledare som rekommenderas att placeras ut på stationer som påverkas av avbrottet. Antalet definieras i åtgärdskortet.",
  Kupé: "Kupé",

  "Lagre regel": "Spara regel",
  Land: "Land",
  "Last på nytt": "Ladda om",
  "Laster innhold": "Laddar innehåll",
  "Laster...": "Laddar...",
  "laste siden": "ladda sidan",
  "Legg inn dine detaljer her": "Lägg in dina detaljer här",
  "Legg til regel": "Lägg till regel",
  Lenker: "Länkar",
  "Likevel berørt": "Ändå påverkad",
  "Logg inn": "Logga in",
  "Logg ut": "Logga ut",
  "Logg ut av Dashboard": "Logga ut från Dashboard",
  Lok: "Lok",
  "Lok / Kond": "Lok / Kond",
  "Lok og vogn": "Lok och vagn",
  Lukk: "Stäng",
  "Lukk alle": "Stäng alla",
  lør: "lör",

  man: "mån",
  "Marker alle": "Markera alla",
  "Marker alle tog": "Markera alla tåg",
  "Marker tog i listen under": "Markera tåg i listan nedan",
  "Manglende betalingsvalg": "Saknad betalningsval",
  "mangler utfylling": "saknar ifyllning",
  "Mangler utfylling": "Saknar ifyllning",
  MaxiTaxi: "MaxiTaxi",
  "Mellom kl {{startTime}} og {{endTime}}, {{days}}":
    "Mellan kl {{startTime}} och {{endTime}}, {{days}}",
  "Mellom stasjoner": "Mellan stationer",
  min: "min",
  Minibuss: "Minibuss",
  "min forsinket": "min sent",
  "min for tidlig": "min före",
  Monitorer: "Monitorer",
  Mottakere: "Mottagare",
  Mynt: "Mynt",
  "Mørk modus": "Mörkt läge",
  "Må behandles": "Måste behandlas",
  "Målt antall passasjerer": "Faktiskt antal resenärer",

  "Nei, behold": "Nej, behåll",
  Neste: "Nästa",
  "Neste togserie": "Nästa tågserie",
  "Nettverksfeil i Dashboard": "Nätverksfel i Dashboard",
  "Noe gikk galt under innlogging. Forsøk å":
    "Något gick fel vid inloggning. Försök att",
  "Noe gikk galt! Last på nytt eller ": "Något gick fel! Ladda om eller ",
  "Noe gikk galt ved henting av hendelser, aksjonskort, årsaker og konsekvenser. Last siden på nytt for å prøve igjen. Ta kontakt med IT hvis feilen vedvarer.":
    "Något gick fel vid hämtning av händelser, störningsplaner, orsaker och konsekvenser. Ladda sidan igen för att försöka igen. Kontakta IT om felet kvarstår.",
  "Noe gikk galt ved henting av prognoser. Last siden på nytt for å prøve igjen. Ta kontakt med IT hvis feilen vedvarer.":
    "Något gick fel vid hämtning av prognoser. Ladda sidan igen för att försöka igen. Kontakta IT om felet kvarstår.",
  "Noe gikk galt ved lasting av innhold.":
    "Något gick fel när innehållet laddades.",
  "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ":
    "Något gick fel när innehållet laddades. Ladda om sidan för att försöka igen. Om felet kvarstår, ",
  "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Ta kontakt med IT":
    "Något gick fel när innehållet laddades. Vänligen ladda sidan igen för att försöka igen. Kontakta IT",
  "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ta kontakt med IT.":
    "Något gick fel när innehållet laddades. Ladda sidan igen för att försöka igen. Om felet kvarstår, kontakta IT.",
  "Noe gikk galt, vennligst prøv igjen": "Något gick fel, vänligen försök igen",
  "Noen tog i serien(e) kjører ulike traseer":
    "Vissa tåg i serien(e) går olika rutter",
  "Noen tog i samme serie kjører i ulike traséer. Sjekk at du velger riktige tog til behandling:":
    "Vissa tåg i samma serie kör olika sträckor. Kontrollera att du väljer rätt tåg för behandling:",
  "Sjekk at du velger riktige tog": "Kontrollera att du väljer rätt tåg",
  "Sjekk at du velger riktige tog til behandling.":
    "Kontrollera att du väljer rätt tåg för behandling.",
  "Noen valgte tog kjører ulike traseer. Sjekk at du velger riktige tog til behandling.":
    "Vissa valda tåg kör olika sträckor. Kontrollera att du väljer rätt tåg för behandling.",
  Norge: "Norge",
  Norsk: "Norska",
  "Norsk beskrivelse": "Svensk beskrivning",
  "Norsk tekst": "Norsk text",
  "Norsk tittel": "Norsk titel",
  "Nullstill søk": "Återställ sökning",
  "Ny hendelse": "Ny händelse",
  "Ny kapasitet": "Ny kapacitet",
  "Ny rute": "Ny rutt",
  "Når skjedde det? Har det skjedd flere ganger?":
    "När hände det? Har det hänt flera gånger?",

  "og type hendelse": "och typ av händelse",
  ons: "ons",
  "Oisann! Her mangler det data for hendelsen.":
    "Hoppsan! Det saknas data för händelsen.",
  "Oisann! Her var visst ingen kundeveiledere satt opp.":
    "Hoppsan! Det verkar inte finnas några kundvägledare inlagda.",
  Operativt: "Operativt",
  Opprett: "Skapa",
  "Opprettet av": "Skapad av",
  "Opprett hendelse for": "Skapa händelse för",
  Oppstått: "Uppstått",
  Oppsummering: "Sammanfattning",
  Oversikt: "Översikt",
  "Oversikt hendelser": "Översikt händelser",

  "Passerer gjennom": "Passerar genom",
  "Passerte brudd: {{time}}": "Passerade störning {{time}}",
  "(planlagt)": "(planerad)",
  Planlagt: "Planerad",
  "Planlagte hendelser": "Planerade händelser",
  Pluss: "Pluss",
  PlussNatt: "PlussNatt",
  Produksjonsavvik: "Produktionsavvik",
  produksjonsavvik: "produktionsavvik",
  "Produksjonsavvik endret": "Produktionsavvik ändrad",
  "Produksjonsavvik opprettet": "Produktionsavvik skapad",
  "Produkter som mangler:": "Produkter som saknas:",
  "Produkt mangler": "Produkt saknas",
  Prognose: "Prognos",
  "Prøver igjen... Forsøk {{attemptNumber}}/5":
    "Försöker igen... Försök {{attemptNumber}}/5",
  "Prøver igjen om {{cooldownRemaining}} sekunder... Forsøk {{attemptNumber}}/5":
    "Försöker igen om {{cooldownRemaining}} sekunder... Försök {{attemptNumber}}/5",
  "Prøv igjen": "Försök igen",
  "Prøv på nytt": "Försök på nytt",
  "Prøv på nytt, eller kontakt IT hvis feilen vedvarer.":
    "Försök på nytt, eller kontakta IT om felet kvarstår.",
  på: "på",
  "på nytt, eller": "på nytt, eller",
  "På stasjon": "På station",
  Påstigning: "Påstigning",
  "Påvirkede stasjoner": "Påverkade stationer",
  "Påvirker direkte": "Påverkar direkt",

  Rediger: "Redigera",
  "Rediger regel": "Redigera regel",
  "Redusert kapasitet": "Reducerad kapacitet",
  Reservebuss: "Reservebuss",
  Rolle: "Roll",
  Rød: "Röd",

  "Samme trasé er valgt i en annen hendelse":
    "Samma trasé är vald i en annan händelse",
  Seddel: "Sedel",
  "Se detaljer": "Se detaljer",
  Selskap: "Företag",
  "Sent satt opp": "Sent satt upp",
  "Se oppsummering": "Se sammanfattning",
  "Siste tekst": "Senaste text",
  "Skjul togliste": "Dölja tåglista",
  "Slett regel": "Radera regel",
  Sluttdato: "Slutdatum",
  Sluttidspunkt: "Sluttidspunkt",
  Sovevogn: "Sovvagn",
  "Spesifikt tidspunkt": "Specifikt tidpunkt",
  Spor: "Spår",
  Startdato: "Startdatum",
  Starttidspunkt: "Starttidspunkt",
  Stasjon: "Station",
  Stasjonshendelse: "Stationshändelse",
  stasjonshendelse: "stationshändelse",
  Stasjonsvalg: "Stationsval",
  "Steg for å reprodusere feilen": "Steg för att reproducera felet",
  Stille: "Tyst",
  Stopper: "Stoppar",
  "Stopper ekstra": "Stoppar extra",
  "Stopp på valgt strekning er allerede innstilt":
    "Stopp på vald sträcka är redan inställt",
  "Strekning:": "Sträcka:",
  Svensk: "Svenska",
  "Svensk tekst": "Svensk text",
  "Svensk tittel": "Svensk titel",
  Sverige: "Sverige",
  Sykkelplass: "Cykelplats",
  Synlig: "Synlig",
  Synlighet: "Synlighet",
  "Tid fra": "Tid från",
  "Tid til": "Tid till",
  "Synlig nå": "Synlig nu",
  Søk: "Sök",
  "Søk etter tognr., stasjon eller stikkord":
    "Sök efter tågnr., station eller nyckelord",
  "Søk på skiftnr, stasjon eller tlfnr": "Sök på skiftnr, station eller tlfnr",
  "Søk på skiftnr, stasjon, tlfnr eller tognr":
    "Sök på skiftnr, station, tlfnr eller tågnr",
  "Søk på tognummer": "Sök på tågnummer",
  "Søk på tognr, stasjon, linjenr eller sett-ID":
    "Sök på tågnr, station, linjenr eller sett-ID",
  "Søk etter strekning, type hendelse...": "Sök efter sträcka, händelsetyp...",
  søn: "sön",

  "Kontakt IT": "Kontakta IT",
  "Ta kontakt med din nærmeste leder dersom du har behov for tilgang.":
    "Kontakta din närmaste chef om du behöver tillgång.",
  "ta kontakt med IT": "kontakta IT",
  "ta kontakt med IT.": "kontakta IT.",
  Taxi: "Taxi",
  "Tekniske detaljer": "Tekniska detaljer",
  Tid: "Tid",
  "Tid til brudd: {{time}}": "Tid till störning: {{time}}",

  "Tidene kan avvike litt avhengig av datagrunnlag":
    "Tiderna kan variera något beroende på datakällor",
  Tidshorisont: "Tidshorisont",
  "Tidshorisont i min.": "Tidshorisont i min.",
  Tidsperiode: "Tidsperiod",
  til: "till",
  Til: "Till",
  Tilbake: "Tilbaka",
  Tilbakemelding: "Feedback",
  "Tilbakemelding fra Drops Dashboard": "Feedback från Drops Dashboard",
  "Tilbakestill filter": "Återställ filter",
  "Til dato": "Till datum",
  "Til kl": "Till kl",
  "Tilknyttet hendelse": "Relaterad händelse",
  "Tilknyttet stasjoner": "Relaterad station",
  "Tilknyttet tog": "Relaterad tåg",
  "Til og med stasjon*": "Till och med station*",
  Tilstand: "Tillstånd",
  "Til stasjon*": "Till station*",
  tir: "tis",
  Tjenestevarsling: "Tjänstemeddelande",
  Tognr: "Tågnr",
  Tidspunkt: "Tidpunkt",
  Tog: "Tåg",
  Togtype: "Tågtyp",
  Status: "Status",
  "Nullstill filter": "Återställ filter",
  "Nullstill filtre": "Återställ filter",
  "Vis fullførte": "Visa slutförda",
  "Vis fullførte oppgaver": "Visa slutförda uppgifter",
  "Toget har allerede passert stasjonen.":
    "Tåget har redan passerat stationen.",
  Toghendelse: "Tåghändelse",
  toghendelse: "tåghändelse",
  Togkart: "Tågkarta",
  Togliste: "Tåglista",
  Togserie: "Tågserie",
  tor: "tors",
  Trasé: "Trasé",
  treff: "träffar",
  Trusselnivå: "Hotnivå",
  "Trådløst internett": "Trådlöst internet",
  "Tøm søkefeltet for å bruke tidsvelgeren":
    "Töm sökfältet för att använda tidsväljaren",
  Type: "Typ",

  Ubehandlet: "Obehandlad",
  "Ukjent kjøretøy": "Okänt fordon",
  uke: "vecka",
  "Ukjent navn": "Okänt namn",
  Usynlig: "Osynlig",
  "Utgangstid (min)": "Utgångstid (min)",
  Utgått: "Gått ut",

  "Valgte tog i serien:": "Valda tåg i serien:",
  "Valgt togserie_one": "Vald tågserie",
  "Valgt togserie_other": "Valda tågserier",
  "Vedlegg gjerne et skjermbilde av hele skjermen (Trykk på windows knapp, shift og S)":
    "Bifoga gärna en skärmbild av hela skärmen (Tryck på Windows-knappen, shift och S)",
  "Velg alle": "Välj alla",
  "Velg alle tog": "Välj alla tåg",
  "Velg annen på stasjon-stopp enn siste stopp":
    'Välj annan "på station"-stopp än sista stopp',
  "Velg berørte tog for togserie": "Välj påverkade tåg för tågserie",
  "Velg berørte togserier": "Välj påverkade tågserier",
  "Velg dato": "Välj datum",
  "Velg en": "Välj en",
  "Velg en infrastrukturhendelse": "Välj en infrastrukturhändelse",
  "Velg en strekning": "Välj en sträcka",
  "Velg hvor produktene mangler": "Välj var produkterna saknas",
  "Velg nivå": "Välj nivå",
  "Velg omkjøringer:": "Välj omledningssträckor:",
  "Velg påvirkede systemer": "Välj påverkade system",
  "Velg stasjon": "Välj station",
  "Velg trusselnivå": "Välj hotnivå",
  "Vennligst ta kontakt med IT": "Vänligen kontakta IT",
  Versjon: "Version",
  Versjonsdato: "Versionsdatum",
  via: "via",
  "Vil du forkaste endringene?": "Vill du förkasta ändringarna?",
  Vis: "Visa",
  "Vis alle": "Visa alla",
  "Viser {{count}} av {{total}}": "Visar {{count}} av {{total}}",
  "Vis frem i tid": "Visa framåt i tid",
  "Vis lukkede": "Visa stängda",
  "Vis mindre": "Visa mindre",
  "Vis tog med manglende data": "Visa tåg med saknad data",
  "Vis passerte tog": "Visa passerade tåg",
  "Vis skjulte": "Visa dolda",
  "Vis slettede": "Visa raderade",
  Vogner: "Vagnar",
  VY: "VY",
  VYT: "VYT",

  "Økt kapasitet": "Ökad kapacitet",
  Øvrige: "Övriga",

  Åpen: "Öppen",
  Årsak: "Orsak",
};
